const styles = () => ({
  copyRightLink: {
    textDecoration: 'none',
  },
});

export default styles;
